module.exports = __webpack_public_path__ + "img/yuangong.b8f4f7dd.png";